import React, { useEffect, useState } from "react";
import { withFormik, Form, Field } from "formik";
import { Link } from "react-router-dom";
import { signup } from "../../api/auth/authApi";
import { auth } from "../../utils/firebase";
import PasswordStrengthMeter from "../shared/PasswordStrengthMeter";

//OPTIONAL:
//add phoneNumberField.js

const validate = (values, props) => {
  let errors = {};

  if (!values.userName) {
    errors.userName = "Enter a username";
  }

  if (!values.email) {
    errors.email = "Email is required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = "Invalid email address";
  }

  if (!values.password) {
    errors.password = "Password is required";
  }

  if (values.password.toLowerCase() === values.password) {
    errors.password = "Invalid password";
  }

  if (values.password.toUpperCase() === values.password) {
    errors.password = "Invalid password";
  }

  if (!/\d/.test(values.password)) {
    errors.password = "Invalid password";
  }

  if (values.password.length < 8) {
    errors.password = "Invalid password";
  }

  if (!/[._()~`!#@$%\^&*+=\-\[\]\\';,/{}|//":<>\?]/g.test(values.password)) {
    errors.password = "Invalid password";
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = "Confirm your password";
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = "Passwords don't match";
  }

  return errors;
};

const handleSignup = (credentials) => {
  const { email, password, userName, phone } = credentials;

  return auth()
    .createUserWithEmailAndPassword(email, password)
    .then((firebaseData) => {
      return signup({
        email,
        phone,
        firebase_uid: firebaseData.user.uid,
        displayName: userName,
      });
    });
};

const styles = {
  display: "none",
};

const RegistrationComponent = (props) => {
  const {
    values,
    handleChange,
    setFieldValue,
    setFieldTouched,
    dirty,
    errors,
    touched,
    isSubmitting,
  } = props;

  const [capsLock, setCapsLock] = useState(false);

  useEffect(() => {
    document.title = "Cookbook Registration";
  }, []);

  const handleKeyDown = (e) => {
    const checkLock = e.getModifierState("CapsLock");
    setCapsLock(checkLock);
  };

  return (
    <div className="d-flex flex-column align-items-center">
      <div className="form-container">
        <h2>Registration</h2>
        <Form className="App-form" onKeyDown={handleKeyDown}>
          <div
            className={
              "form-group form-group-lg " +
              (errors.userName && touched.userName ? "has-error" : "")
            }
          >
            <label htmlFor="userName" className="control-label">
              Username<span className="text-danger">*</span>
            </label>
            <Field
              id="userName"
              type="userName"
              className="form-control"
              name="userName"
              value={values.userName}
              onChange={handleChange}
              maxLength="50"
            />
            {errors.userName && touched.userName && (
              <div className="text-danger exception-margin" role="alert">
                <span
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Error:</span>{" "}
                {touched.userName && errors.userName}
              </div>
            )}
          </div>
          <div
            className={
              "form-group form-group-lg " +
              (errors.email && touched.email ? "has-error" : "")
            }
          >
            <label htmlFor="email" className="control-label">
              Email <span className="text-danger">*</span>
            </label>
            <Field
              type="email"
              aria-describedby="emailAddressHelpBlock"
              className="form-control"
              name="email"
              value={values.email}
              onChange={handleChange}
              maxLength="50"
            />
            {errors.email && touched.email && (
              <div className="exception-margin text-danger" role="alert">
                <span
                  className="glyphicon glyphicon-warning-sign"
                  aria-hidden="true"
                >
                  <span className="sr-only">Error:</span>
                </span>{" "}
                {touched.email && errors.email}
              </div>
            )}
          </div>
          <div
            className={
              "form-group form-group-lg password-form-group " +
              (errors.password && touched.password ? "has-error" : "")
            }
          >
            <label htmlFor="password" className="control-label">
              Password <span className="text-danger">*</span>
            </label>
            <Field
              type="password"
              className="form-control password-field"
              name="password"
              value={values.password}
              onChange={handleChange}
              maxLength="20"
            />
            {capsLock && (
              <div
                className="exception-margin invalid-password"
                style={{ marginBottom: "10px" }}
              >
                <span className="text-warning" role="alert">
                  <span
                    className="glyphicon glyphicon-warning-sign"
                    aria-hidden="true"
                  ></span>
                  <span className="sr-only">Caps Lock is ON</span>
                </span>{" "}
                Caps Lock is ON
              </div>
            )}
            <PasswordStrengthMeter password={values.password} />
            {errors.password && touched.password && (
              <div
                className="text-danger exception-margin invalid-password"
                role="alert"
              >
                <span
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Error:</span>{" "}
                {touched.password && errors.password}
              </div>
            )}
            <p className="password-policy">
              Password must be 8 to 20 characters and contain at least one
              lowercase and uppercase letter, one number and one special
              character.
            </p>
          </div>
          <div
            className={
              "form-group form-group-lg " +
              (errors.confirmPassword && touched.confirmPassword
                ? "has-error"
                : "")
            }
          >
            <label htmlFor="confirmPassword" className="control-label">
              Confirm Password <span className="text-danger">*</span>
            </label>
            <Field
              type="password"
              className="form-control password-field"
              name="confirmPassword"
              value={values.confirmPassword}
              onChange={handleChange}
              maxLength="20"
            />
            {errors.confirmPassword && touched.confirmPassword && (
              <div
                className="text-danger exception-margin invalid-password"
                role="alert"
              >
                <span
                  className="glyphicon glyphicon-exclamation-sign"
                  aria-hidden="true"
                ></span>
                <span className="sr-only">Error:</span>{" "}
                {touched.confirmPassword && errors.confirmPassword}
              </div>
            )}
          </div>
          <div style={styles}>
            <Field name="userType" />
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-lg btn-block"
            disabled={
              !dirty || Object.keys(errors).length !== 0 || isSubmitting
            }
          >
            Register
          </button>
        </Form>
        <div className="return-link">
          <p>
            Already registered? <Link to="/cookbook/login">Login</Link>
          </p>
        </div>
      </div>
    </div>
  );
};

const Registration = withFormik({
  mapPropsToValues({
    email,
    userName,
    phone,
    password,
    confirmPassword,
    showNotification,
    hideNotification,
  }) {
    return {
      email: email || "",
      userName: userName || "",
      phone: phone || "",
      password: password || "",
      confirmPassword: confirmPassword || "",
      showNotification,
      hideNotification,
    };
  },
  validate: validate,
  handleSubmit(values, { props, setSubmitting }) {
    let { email, userName, phone, password } = values;
    // phone = phone.replace(/[^0-9]/gi, "");
    const credentials = {
      email,
      userName,
      phone,
      password,
    };
    return handleSignup(credentials).catch((error) => {
      setSubmitting(false);

      props.showNotification({
        type: "failure",
        title: "Registration failed",
        message: "Please try again",
      });
    });
  },
})(RegistrationComponent);

export default Registration;
